import { BASE_ADDRESS } from './serviceConstant';

export const CONTENT_API_URL =
  BASE_ADDRESS + '/StreamCo/react-coding-challenge/master/feed/sample.json';

export const CONTENT_PROGRAM_TYPE_SERIES = 'series';
export const CONTENT_PROGRAM_TYPE_MOVIES = 'movie';
export const CONTENT_MIN_RELEASE_YEAR = 2010;
export const CONTENT_MAX_DISPLAY_COUNT = 21;
